import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Secure";
import { useTranslation } from "react-i18next";
import useCheckCompatibility from "../../hooks/useCheckCompatibility";
import Footer from "../../components/Footer";
import LiveChat from "../../components/LiveChat";
import { Typography } from "@mui/material";
import Report from "views/Secure/Reports";
import OtherReports from "views/Secure/Reports/Others";
import Accounts from "views/Secure/Accounts";

const customStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100vh",
    background: "rgba(237, 241, 247, 1)",
  },
  mainPanel: {
    height: "100%",
    width: "100%",
  },
  container: {
    paddingRight: "15px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto",
    position: "relative",
    "@media print": {
      padding: 0,
      margin: 0,
      background: "rgb(255 255 255)",
    },
  },
};
const components = {
  "teachers-reports": <Report />,
  "grades-reports": <Report />,
  "other-reports": <OtherReports />,
  accounts: <Accounts />,
};
function Layouts() {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState(i18n.dir());
  const isNotCompatible = useCheckCompatibility();

  useEffect(() => {
    const authToken = localStorage.getItem("abjadToken");
    if (isNotCompatible) {
      const restoreId = localStorage.getItem("restoreId");
      localStorage.clear();
      if (restoreId) localStorage.setItem("restoreId", restoreId);
      window.location = "/login";
    } else if (!authToken) navigate("/login");
  }, []);

  useEffect(() => {
    setDirection(i18n.dir());
  }, [i18n.dir()]);
  return (
    <Typography component="div" sx={{ ...customStyles.wrapper, direction }}>
      <LiveChat />
      <Header />
      <Typography component="div" sx={customStyles.mainPanel}>
        <Typography component="div" sx={customStyles.container}>
          {components[location.pathname.split("/")[1]]}
        </Typography>
      </Typography>
      <Footer />
    </Typography>
  );
}

export default Layouts;
